import Vue from 'vue'
import el from "element-ui/src/locale/lang/el";

/**
 * 给图片添加fasttfs地址
 * @param imgUrl
 * @returns {string}
 */
export function fastImg (imgUrl) {
  return process.env.IMG_SHOW_URL + "/" + imgUrl
}

// export function requireImg(imgUrl) {
//   console.warn(imgUrl)
//   return require(imgUrl)
// }

/**
 * 用户身份
 * @param type
 * @returns {string}
 */
export function userType (type) {
  if (type == 1) {
    return '教师'
  } else if (type == 2) {
    return '学生'
  } else if (type == '') {
    return ''
  } else {
    return '未知身份'
  }
}



// WEBPACK FOOTER //
// ./src/utils/filters.js